var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH673(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffdf97;}.cls-2{fill:#ea8b49;}.cls-3{fill:#ffbf57;}.cls-4{fill:#efecea;}.cls-5{fill:#cecece;}.cls-6{fill:#d37a3d;}.cls-7{fill:#6dd3ce;}.cls-8{stroke:#fff;stroke-width:5.67px;}.cls-8,.cls-9{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-10{fill:#fff;opacity:0;}.cls-9{stroke:#ffd15c;stroke-width:8.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.48,157.24c-13.06,0-26.01-5.68-34.83-16.62-15.46-19.18-12.43-47.37,6.75-62.83,19.18-15.46,47.37-12.43,62.83,6.75h0c15.46,19.18,12.43,47.37-6.75,62.83-8.24,6.64-18.15,9.88-28,9.88Zm-.07-72.33c-6.1,0-12.23,2-17.34,6.12-11.88,9.58-13.75,27.03-4.18,38.91,9.58,11.88,27.03,13.75,38.91,4.18,11.88-9.58,13.75-27.03,4.18-38.91h0c-5.46-6.77-13.48-10.29-21.57-10.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 127.66,
    y: 129.97,
    width: 18.43,
    height: 54.37,
    rx: 2.53,
    ry: 2.53,
    transform: "translate(-68.32 120.7) rotate(-38.87)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M158.76,127.34c-18.83,42.72-77.52,52.09-108.7,17.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M162.68,115.55c-.18,.68-.38,1.37-.58,2.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.75,81.75c19.77-60.58,104.31-61.2,125.22-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.27,92.74c.09-.67,.19-1.34,.31-2.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.07,
    y: 116.57,
    width: 16.46,
    height: 16.46,
    rx: 8.23,
    ry: 8.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.69,
    y: 119.49,
    width: 38.15,
    height: 10.63,
    rx: 1.07,
    ry: 1.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 86.5,
    y: 135.97,
    width: 16.46,
    height: 16.46,
    rx: 8.23,
    ry: 8.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 108.74,
    y: 138.88,
    width: 38.15,
    height: 10.63,
    rx: 1.07,
    ry: 1.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.84,
    y: 67.72,
    width: 16.46,
    height: 16.46,
    rx: 8.23,
    ry: 8.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 125.88,
    y: 69.99,
    width: 35.53,
    height: 9.9,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 86.5,
    y: 47.98,
    width: 16.46,
    height: 16.46,
    rx: 8.23,
    ry: 8.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 108.49,
    y: 50.26,
    width: 35.53,
    height: 9.9,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.2,120.83c-9.3-2.95-22.38-12.69-22.38-12.69l-3.75,2.67s4.9,15.55,4.64,25.31l-.09,3.11c4.03,5.67,10.84,4.12,17.91-.8,6.97-5.07,10.68-10.98,6.64-16.66l-2.97-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.39,122.35c-4.77-1.51-11.47-6.51-11.47-6.51l-1.92,1.37s2.51,7.97,2.38,12.98l-.05,1.6c2.07,2.91,5.56,2.11,9.19-.41,3.58-2.6,5.47-5.63,3.41-8.54l-1.52-.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.34,56.78c-3.58,0-6.48-4.63-6.48-6.8,0-.36-.77-.36-.77,0,0,2.08-2.67,6.8-6.89,6.8-.36,0-.36,.77,0,.77,3.68,0,6.89,5.04,6.89,6.8,0,.36,.77,.36,.77,0,0-2.09,2.99-6.8,6.48-6.8,.36,0,.36-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.6,103.89c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 84.62,
    y: 85.95,
    width: 29.18,
    height: 29.18,
    rx: 14.59,
    ry: 14.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 119.71,
    y: 91.62,
    width: 59.64,
    height: 17.86,
    rx: 1.73,
    ry: 1.73
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "99.21 92.63 99.21 102.32 104.97 100.09"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.51,149.71c-13.48,0-26.84-5.86-35.94-17.15-15.95-19.79-12.83-48.87,6.96-64.82,19.79-15.95,48.87-12.83,64.82,6.96h0c15.95,19.79,12.83,48.87-6.96,64.82-8.51,6.85-18.73,10.19-28.89,10.19Zm-.07-72.33c-5.79,0-11.61,1.9-16.45,5.8-11.27,9.08-13.05,25.65-3.96,36.92,9.08,11.27,25.65,13.05,36.92,3.96,11.27-9.08,13.05-25.65,3.96-36.92h0c-5.18-6.43-12.79-9.77-20.47-9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.17,165.19l-10.41,8.39c-1.09,.88-2.68,.71-3.56-.38l-30.94-38.39c-.88-1.09-.71-2.68,.38-3.56l10.41-8.39c1.09-.88,2.68-.71,3.56,.38l31.5,31.65s.04,7.88,0,8.5c-.05,.68-.37,1.33-.94,1.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.51,141.3c-13.48,0-26.84-5.86-35.94-17.15-15.95-19.79-12.83-48.87,6.96-64.82,19.79-15.95,48.87-12.83,64.82,6.96h0c15.95,19.79,12.83,48.87-6.96,64.82-8.51,6.85-18.73,10.19-28.89,10.19Zm-.07-72.33c-5.79,0-11.61,1.9-16.45,5.8-11.27,9.09-13.05,25.65-3.96,36.92,9.08,11.27,25.65,13.05,36.92,3.97,11.27-9.08,13.05-25.65,3.96-36.92h0c-5.18-6.43-12.79-9.77-20.47-9.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 127.69,
    y: 112.63,
    width: 18.43,
    height: 54.37,
    rx: 2.53,
    ry: 2.53,
    transform: "translate(-57.42 116.88) rotate(-38.87)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH673);
export default __webpack_public_path__ + "static/media/H67-3.79950a44e1456ee22c3b57c132aaf9c0.svg";
export { ForwardRef as ReactComponent };